
import Map from "../../components/Map";
import "../pages/styles/AlertPage.css";
function MapPage() {
  return (
    <div className="wildlife-container">
      <div className="sections1">

      </div>

      <div className="areaMap-Mappage">
        <Map />
      </div>
    </div>
  );
}

export default MapPage;
